import { moduleName } from './module';
import './directive';

export default moduleName;
